import ManTechCar25Component from 'components/marketingSite/mantechcar25/ManTechCar';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Script from 'next/script';
import { ServiceServicePublicStats } from 'services/service.public-stats';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type ManTechCar25PageProps = WithBaseUrl & { manfreditesCount: number };

const ManTechCar25Page: React.FC<ManTechCar25PageProps> = ({
  baseUrl,
  manfreditesCount
}) => {
  const { t } = useI18n('developer-career-report-2025');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('mantechcar25.page_title')}
        url={APP_URLS.mantechcar25}
        desc={t('mantechcar25.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_tech_career_report_2025.png'
        )}`}
        indexable={true}
      />
      <Script
        id="devCareerReportLD"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{
  "@context": "https://schema.org",
  "@type": "Report",
  "name": "${t('mantechcar25.page_title')}",
  "url": "https://www.getmanfred.com/developer-career-report",
  "description": "${t('mantechcar25.page_description')}",
  "author": {
    "@type": "Organization",
    "name": "Get Manfred",
    "url": "https://www.getmanfred.com",
    "logo": {
      "@type": "ImageObject",
       "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",
    }
  },
  "publisher": {
    "@type": "Organization",
    "name": "Manfred",
    "url": "https://www.getmanfred.com"
  },
  "datePublished": "2025-11-04",
  "mainEntityOfPage": "https://www.getmanfred.com/developer-career-report",
  "articleSection": "Carrera de Desarrolladores, Oportunidades en IT, Tendencias del Sector"
}`
        }}
      />
      <ManTechCar25Component manfreditesCount={manfreditesCount} />
    </>
  );
};

export default ManTechCar25Page;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const { manfreditesCount } = await ServiceServicePublicStats.get();

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'developer-career-report-2025'
      ])),
      baseUrl: config.appUrl,
      manfreditesCount
    },
    revalidate: 30
  };
};
